/**
 * 打开准时保landing页面
 * @param params
 */
export function openPunctualLandingPage(params = {}, data = {}) {
  const schemeUrl = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_punctual';
  const Router = Mach.requireModule('Router');
  Router.navigateTo(buildUrl(schemeUrl, params), data);
}

/**
 * 打开准时保规则页面
 * @param params
 */
export function openPunctualRulePage(params = {}, data = {}) {
  const schemeUrl = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_punctual_rule';
  const Router = Mach.requireModule('Router');
  Router.navigateTo(buildUrl(schemeUrl, params), data);
}

/**
 * 拼接通参
 * @param url
 * @param params
 * @returns
 */
export function buildUrl(url: string, params = {}): string {
  const buildQueryString = (params): string => Object.keys(params)
    .filter((key) => params[key])
    .map((key) => `${key}=${params[key]}`)
    .join('&');

  const queryString = buildQueryString(params);
  if (queryString) {
    url += (url.includes('?') ? '&' : '?') + queryString;
  }
  return url;
}
